// extracted by mini-css-extract-plugin
export default {"mainPage_section":"MainPage_mainPage_section__Il8Bd"};